module.exports = __webpack_public_path__ + "images/emoji/sweat.574ae87a3a8b1c1a62b0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sweat.png
// module id = XRql
// module chunks = 24